/** Couleurs atténuées, stables par identifiant joueur (ordre trié des ids). */
export interface PlayerColor {
  rowBackground: string;
  rowBorder: string;
  cardBackground: string;
  cardBorder: string;
  cardGradientFrom: string;
  cardGradientTo: string;
  dot: string;
}

const PALETTE: PlayerColor[] = [
  {
    rowBackground: "rgba(22, 58, 56, 0.42)",
    rowBorder: "rgba(56, 130, 120, 0.32)",
    cardBackground: "rgba(16, 48, 46, 0.72)",
    cardBorder: "rgba(56, 130, 120, 0.38)",
    cardGradientFrom: "rgba(22, 70, 66, 0.55)",
    cardGradientTo: "rgba(12, 36, 34, 0.65)",
    dot: "#4a9e94",
  },
  {
    rowBackground: "rgba(32, 44, 78, 0.42)",
    rowBorder: "rgba(88, 112, 180, 0.32)",
    cardBackground: "rgba(24, 34, 62, 0.72)",
    cardBorder: "rgba(88, 112, 180, 0.38)",
    cardGradientFrom: "rgba(36, 52, 96, 0.55)",
    cardGradientTo: "rgba(18, 26, 48, 0.65)",
    dot: "#7a8fd4",
  },
  {
    rowBackground: "rgba(58, 44, 28, 0.42)",
    rowBorder: "rgba(160, 120, 72, 0.32)",
    cardBackground: "rgba(46, 34, 20, 0.72)",
    cardBorder: "rgba(160, 120, 72, 0.38)",
    cardGradientFrom: "rgba(72, 54, 32, 0.55)",
    cardGradientTo: "rgba(36, 26, 14, 0.65)",
    dot: "#b8925c",
  },
  {
    rowBackground: "rgba(58, 32, 48, 0.42)",
    rowBorder: "rgba(150, 88, 130, 0.32)",
    cardBackground: "rgba(46, 24, 38, 0.72)",
    cardBorder: "rgba(150, 88, 130, 0.38)",
    cardGradientFrom: "rgba(72, 40, 60, 0.55)",
    cardGradientTo: "rgba(34, 18, 28, 0.65)",
    dot: "#b07098",
  },
  {
    rowBackground: "rgba(28, 52, 44, 0.42)",
    rowBorder: "rgba(72, 140, 108, 0.32)",
    cardBackground: "rgba(20, 40, 34, 0.72)",
    cardBorder: "rgba(72, 140, 108, 0.38)",
    cardGradientFrom: "rgba(32, 64, 52, 0.55)",
    cardGradientTo: "rgba(14, 30, 24, 0.65)",
    dot: "#6aab88",
  },
  {
    rowBackground: "rgba(36, 36, 62, 0.42)",
    rowBorder: "rgba(100, 100, 160, 0.32)",
    cardBackground: "rgba(28, 28, 50, 0.72)",
    cardBorder: "rgba(100, 100, 160, 0.38)",
    cardGradientFrom: "rgba(44, 44, 78, 0.55)",
    cardGradientTo: "rgba(20, 20, 38, 0.65)",
    dot: "#8888c8",
  },
  {
    rowBackground: "rgba(52, 38, 32, 0.42)",
    rowBorder: "rgba(150, 100, 88, 0.32)",
    cardBackground: "rgba(40, 28, 24, 0.72)",
    cardBorder: "rgba(150, 100, 88, 0.38)",
    cardGradientFrom: "rgba(64, 44, 36, 0.55)",
    cardGradientTo: "rgba(32, 22, 18, 0.65)",
    dot: "#c08878",
  },
  {
    rowBackground: "rgba(32, 48, 58, 0.42)",
    rowBorder: "rgba(80, 130, 160, 0.32)",
    cardBackground: "rgba(22, 38, 48, 0.72)",
    cardBorder: "rgba(80, 130, 160, 0.38)",
    cardGradientFrom: "rgba(36, 58, 72, 0.55)",
    cardGradientTo: "rgba(16, 28, 36, 0.65)",
    dot: "#78aac4",
  },
];

export function buildPlayerColorMap(playerIds: string[]): Map<string, PlayerColor> {
  const sorted = [...new Set(playerIds)].sort();
  const map = new Map<string, PlayerColor>();
  for (let i = 0; i < sorted.length; i += 1) {
    map.set(sorted[i], PALETTE[i % PALETTE.length]);
  }
  return map;
}

export function getPlayerColor(
  playerId: string,
  colorMap: Map<string, PlayerColor>,
): PlayerColor | undefined {
  return colorMap.get(playerId);
}
